module.exports = __webpack_public_path__ + "static/media/letter-t.93b57c5d.png";